var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBtSearchGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#5B57D1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5011 18.2332C28.5011 17.3698 28.4296 16.7398 28.2749 16.0865H18.2153V19.9831H24.1201C24.0011 20.9515 23.3582 22.4098 21.9296 23.3898L21.9095 23.5203L25.0902 25.935L25.3106 25.9565C27.3344 24.1249 28.5011 21.4298 28.5011 18.2332Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2147 28.4998C21.1076 28.4998 23.5361 27.5665 25.31 25.9564L21.929 23.3897C21.0242 24.0081 19.8099 24.4397 18.2147 24.4397C15.3815 24.4397 12.9767 22.6081 12.1195 20.0764L11.9938 20.0869L8.68656 22.5952L8.64331 22.7131C10.4052 26.143 14.0243 28.4998 18.2147 28.4998Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1197 20.0767C11.8935 19.4234 11.7626 18.7234 11.7626 18.0001C11.7626 17.2767 11.8935 16.5767 12.1078 15.9234L12.1018 15.7842L8.75312 13.2356L8.64356 13.2867C7.9174 14.7101 7.50073 16.3084 7.50073 18.0001C7.50073 19.6917 7.9174 21.29 8.64356 22.7134L12.1197 20.0767Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2148 11.56C20.2267 11.56 21.5838 12.4116 22.3577 13.1233L25.3814 10.23C23.5244 8.53834 21.1076 7.5 18.2148 7.5C14.0243 7.5 10.4052 9.85665 8.64331 13.2866L12.1076 15.9233C12.9767 13.3917 15.3815 11.56 18.2148 11.56Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtSearchGoogle);
export default __webpack_public_path__ + "static/media/bt_search_google.84460c2d9d03029d2e7824df8f5b31c6.svg";
export { ForwardRef as ReactComponent };